var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 9a5 5 0 0 1 5-5h21a5 5 0 0 1 5 5v29a5 5 0 0 0 .92 2.9c.5.83 1.16 1.55 1.95 2.1H9a6 6 0 0 1-6-6V9Zm6 1.5a1 1 0 0 1 1-1h17a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1v-8ZM10 25a1 1 0 1 0 0 2h17a1 1 0 1 0 0-2H10Zm-1 5.5a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1Zm1 3.5a1 1 0 1 0 0 2h15a1 1 0 1 0 0-2H10Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4 37.5V22H40c3.31 0 5 2.69 5 6v10a5 5 0 0 1-3.6 4.8h-.7a5.3 5.3 0 0 1-5.3-5.3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewz);
export default __webpack_public_path__ + "static/media/newz.a59584ad499a61b8813f7b685eeaff52.svg";
export { ForwardRef as ReactComponent };